import { ElevatorGroup } from "@/commons/interface/building/elevator-group"
import { StdResponse, bimAxios } from "@/config/axios"


export function getElevatorGroups(projectUuid: string, modelUuid: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/projects/${projectUuid}/elevator-groups`, {
        params: {
            ...params,
            modelUuid: modelUuid,
        }
    })
}

export function addElevatorGroup(projectUuid: string, modelUuid: string, data: ElevatorGroup, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/projects/${projectUuid}/models/${modelUuid}/elevator-groups`, data, {
        params: {
            ...params,
        }
    })
}


export function updateElevatorGroup(uuid: string, data: ElevatorGroup, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.put(`/elevator-groups/${uuid}`, data, {
        params: {
            ...params,
        }
    })
}

export function deleteElevatorGroup(projectUuid: string, elevatorGroupUuid: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.delete(`/projects/${projectUuid}/elevator-groups/${elevatorGroupUuid}`, {
        params: {
            ...params,
        }
    })
}
